import { AccountApi } from 'unit-account/api';
import { Company } from 'unit-account/interfaces/company';


interface User {
  id: string;
  name: string;
  email: string;
}

const getAvatar = (user: User): { type?: string, image_url?: string } => {
  if (!user) {
    return {};
  }

  return {
    type: 'avatar',
    image_url: AccountApi.getAvatarLink({ id: user.id, hasAvatar: true }),
  };
};

const getCompanyAttributes = (company: Company): Record<string, number | string> => {
  if (!company) {
    return null;
  }

  const attributes = {
    id: company.id,
    name: company.name,
  };

  Object.entries(company.subscriptions).forEach(([type, subscription]) => {
    attributes[`${type} Plan`] = subscription.planId;
    attributes[`${type} Status`] = subscription.billingStatus;
    attributes[`${type} Create`] = subscription.createdAt;
    attributes[`${type} Next Billing`] = subscription.nextBillingAt;
    attributes[`${type} Trial End`] = subscription.trialEnd;
    attributes[`${type} License Count`] = subscription.employeesMaxCount;
  });

  return attributes;
};


const getUserModel = (user: User, company: Company, userHash: string, hasAvatar: boolean): {} => {
  const avatar = hasAvatar
    ? getAvatar(user)
    : {};

  return {
    ...user,
    avatar,
    company: getCompanyAttributes(company),
    user_id: user.email,
    user_hash: userHash,
  };
};

export const setIntercomIdentify = (
  user: User,
  company: Company,
  userHash: string,
  hasAvatar: boolean,
): void => {
  if (!user || !user.email || !window.Intercom) {
    return;
  }

  const userModel = getUserModel(user, company, userHash, hasAvatar);
  window.Intercom('update', userModel);
};

export const resetIntercomIdentify = (): void => {
  if (!window.Intercom) {
    return;
  }

  window.Intercom('shutdown');
};

